<template>
    <div class="">
        페이지 준비중 입니다.
    </div>
</template>

<script>
export default {
    name: "Wait Building",
};
</script>